import { useCallback } from 'react';
import { TRACER_STATUS_CODE } from '../../tracer/utils/tracerStatusCode';
import { useWebSocket } from '../../web-socket-provider/hooks/useWebSocket';
import { CHAT_AGENT_MESSAGE_TYPE } from '../config/chatAgentMessageType';
import { useChatAgentTracer } from './useChatAgentTracer';

export const useChatAgentWebSocketTracer = () => {
    const { endTrace, addTraceAttributes, getSpanContext, addEvent } = useChatAgentTracer();

    const traceWsMessage = useCallback(
        message => {
            const traceId = message?.traceId;
            if (!traceId) {
                return;
            }

            const currentTraceId = getSpanContext()?.traceId;
            if (!currentTraceId || currentTraceId !== traceId) {
                return;
            }

            const contextId = message?.contextId;
            const componentName = message?.componentData?.componentName;
            const componentValue = message?.componentData?.value;

            if (
                componentValue === CHAT_AGENT_MESSAGE_TYPE.MESSAGE_END ||
                componentValue === CHAT_AGENT_MESSAGE_TYPE.MESSAGE_ERROR
            ) {
                addTraceAttributes({
                    ...(contextId && { contextId }),
                });
                endTrace(
                    componentValue === CHAT_AGENT_MESSAGE_TYPE.MESSAGE_ERROR
                        ? TRACER_STATUS_CODE.ERROR
                        : TRACER_STATUS_CODE.OK
                );
                return;
            }

            const eventName = `WS_${componentName || CHAT_AGENT_MESSAGE_TYPE.MESSAGE}`;
            addEvent(eventName, { componentName, contextId });
        },
        [addTraceAttributes, endTrace, getSpanContext, addEvent]
    );

    useWebSocket(traceWsMessage);
};
